import React from "react";

export default function TagFilter({ allTags, selected, onChange, color }) {
  if (allTags.length === 0) return null;
  function toggle(t) {
    if (selected.indexOf(t) >= 0) onChange(selected.filter(function (x) { return x !== t; }));
    else onChange(selected.concat([t]));
  }
  return (
    <div style={{ background: "#fff", borderRadius: 10, padding: "10px 14px", marginBottom: 16, border: "1px solid #E2DED5" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, flexWrap: "wrap" }}>
        <span style={{ fontFamily: "'Archivo',sans-serif", fontSize: 11, letterSpacing: 1, color: "#888", fontWeight: 700 }}>FILTER OP TAG:</span>
        {selected.length > 0 && <button onClick={function () { onChange([]); }} style={{ background: "none", border: "none", color: "#E53E3E", fontSize: 11, cursor: "pointer", fontWeight: 700, padding: 0 }}>Wissen ({selected.length})</button>}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
        {allTags.map(function (t, i) {
          var active = selected.indexOf(t) >= 0;
          return (
            <button key={i} onClick={function () { toggle(t); }} style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: .5, padding: "3px 10px", borderRadius: 4, border: "1px solid " + (active ? color : "#E2DED5"), background: active ? color : "#fff", color: active ? "#fff" : "#555", cursor: "pointer" }}>{t}</button>
          );
        })}
      </div>
    </div>
  );
}
